import * as Yup from 'yup';
import PASSWORD_REGEX from './passwordRegex';

export const resetPasswordSchema = (localization: any) => {
    return Yup.object().shape({
        password: Yup.string().matches(new RegExp(PASSWORD_REGEX), localization.errors.pwd_invalid).required(localization.errors.pwd_required),
        passwordConfirm: Yup.string().oneOf([Yup.ref('password'), undefined], localization.errors.not_match)
    });
};
